import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import {  MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
// import { ImageCroppedEvent } from 'ngx-image-cropper';

@Component({
  selector: 'lib-image-cropper',
  templateUrl: './image-cropper.component.html',
  styleUrls: ['./image-cropper.component.scss']
})
export class ImageCropperComponent {

  imageChangedEvent: any = '';
  croppedImage: any = '';
  colorPicked:string = '#ffffff';
  containWithinAspectRatio = false;
  transform: any = {
    scale: 1,
    translateUnit: 'px'
  };
  croppedImageBlob: any;
  screenType: any;
  selectedAspectRatio: any = '1/1';
  formattedSelectedAspectRation: number = 1;
  showColorPicker: boolean = false;
  isRoundedAspect: boolean = false;
  aspectRatio:boolean = false;

  constructor(
    private dialogRef: MatDialogRef<ImageCropperComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {

  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }

  aspectRationChange(event: any) {
    const listNumber = event.target.value.split('/');
    this.formattedSelectedAspectRation = listNumber[0] / listNumber[1];
  }


  imageCropped(event: any) {
    this.croppedImage = event.objectUrl;
    this.croppedImageBlob = event.blob;
  }


  toggleContainWithinAspectRatio() {
    this.transform.scale = 1;
    this.containWithinAspectRatio = !this.containWithinAspectRatio;
  }

  imageTransformed(event:any){
  }

  turnOffFocus(event: any) {
    return event.target.blur();
  }

  handleOkClick() {
    this.dialogRef.close({
      croppedImageFile: new File([this.croppedImageBlob], this.data?.imageFile?.name ?? 'image', { type: this.croppedImageBlob.type }),
      croppedImageUrl:this.croppedImage
    })
  }

  closeDialog(){
    this.dialogRef.close()
  }
}
